module.exports = __webpack_public_path__ + "assets/img/logo.f39797a8.png";